import { useQuery } from '@tanstack/react-query'
import { getTemplateMeals } from './templates.service'

export function useTemplateMeals() {
  return useQuery({
    queryKey: ['templates', 'list'],
    queryFn: getTemplateMeals,
    staleTime: 5 * 60 * 1000,
  })
}
